import flash from "@/services/flash";
import Translator from "@/services/translator";

const isDev = process.env.NODE_ENV !== "production";

function handler(error) {
  const { response = null } = error;

  if (response && response.status >= 500) {
    let { data = null } = response;
    let params = { code: "" };
    if (data && data.code) {
      params.code = data.code;
    }

    const message = Translator.trans("flash.error.generic_error", params);
    flash.error(message, {
      immediate: true,
      title: Translator.trans("flash.error.title"),
    });
  }

  if (isDev) {
    throw error;
  }
}

export default handler;
